import { Refresh } from '@mui/icons-material';
import { Button, Grid } from '@mui/material';
import { ActionBar, Header } from 'src/components/header';
import { PublicationWrapper } from 'src/components/header/actionBar/ActionBar.styled';
import { PublicationModal } from 'src/components/modal';
import { PATHS } from 'src/constants/paths';
import { useModal } from 'src/hooks';
import { useGetPublication } from 'src/hooks/api/publication/useGetPublication';
import { PublicationTypes } from 'src/interfaces';
import { lang, useUserRole } from 'src/utils';

import { ProductPublicationTable } from '../modules/ProductPublicationTable/ProductPublicationTable';
import { ContentContainer, PageContainer } from '../PublicationPage.style';
import { FooterContainer } from './ProductPublicationPage.styled';

export const ProductPublicationPage = () => {
  const publishModal = useModal();
  const { isViewOnly } = useUserRole();
  const { refetch } = useGetPublication(PublicationTypes.PRODUCTS);

  return (
    <PageContainer>
      <ContentContainer>
        <Grid>
          <Header
            breadcrumbItems={[
              {
                label: lang.locations,
                link: `${PATHS.LOCATIONS}`,
              },
              {
                label: lang.publications,
                link: `${PATHS.LIST_PUBLICATIONS}`,
              },
              {
                label: lang.productPublications,
                link: `${PATHS.PRODUCT_PUBLICATIONS}`,
              },
            ]}
            title={lang.productPublications}
            actionBar={
              <PublicationWrapper data-testid="productPublication">
                <ActionBar type={lang.productPublications} />
              </PublicationWrapper>
            }
          />
          <ProductPublicationTable />
        </Grid>
      </ContentContainer>
      <FooterContainer>
        <Button
          variant="outlined"
          startIcon={<Refresh />}
          onClick={() => refetch()}>
          {lang.refresh}
        </Button>
        {!isViewOnly && (
          <Button
            variant="contained"
            data-testid="productPublicationButton"
            onClick={publishModal.onToggleModal}>
            {lang.publish}
          </Button>
        )}
      </FooterContainer>
      <PublicationModal
        open={publishModal.open}
        onClose={publishModal.onCloseModal}
        title={lang.productPublicationModal.title}
        subTitle={lang.productPublicationModal.subTitle}
        publicationType={PublicationTypes.PRODUCTS}
      />
    </PageContainer>
  );
};
